export default __webpack_public_path__ + "static/media/download.5a38736c.svg";